import { Injectable, TransferState, inject } from "@angular/core";
import { TranslateLoader } from "@ngx-translate/core";
import { from, map, Observable, of } from "rxjs";

import { LocaleId } from "@hermes/locale";

import { loadTranslationModule } from "./i18n-loader-map";
import { TRANSLATIONS_CACHE_KEY } from "./translations.constants";

@Injectable()
export class BrowserTranslationLoader implements TranslateLoader {
    private readonly transferState = inject(TransferState);

    public getTranslation(
        localeId: LocaleId,
    ): Observable<Record<string, string>> {
        const translationsFromServer = this.transferState.get(
            TRANSLATIONS_CACHE_KEY,
            undefined,
        );
        if (translationsFromServer) {
            return of(translationsFromServer);
        }

        // Fallback for browser only
        return from(loadTranslationModule(localeId)).pipe(
            map((locale) => locale.translations),
        );
    }
}
